import { supabase } from './supabase'
import { KB_AGENT_BEHAVIOR_SELECT, KB_AGENT_BEHAVIOR_DEFAULTS, normalizeKbAgentBehavior } from './kbSearchDefaults'

export { KB_AGENT_BEHAVIOR_SELECT, KB_AGENT_BEHAVIOR_DEFAULTS, normalizeKbAgentBehavior }

export async function loadKbAgentBehaviorConfig(client = supabase) {
  const { data, error } = await client
    .from('kb_pipeline_configs')
    .select(KB_AGENT_BEHAVIOR_SELECT)
    .is('source_id', null)
    .maybeSingle()

  if (error) throw error
  return normalizeKbAgentBehavior(data)
}

export async function saveKbAgentBehaviorConfig(draft, client = supabase) {
  const payload = {
    agent_chat_enabled: Boolean(draft.agent_chat_enabled),
    agent_max_turns_per_hour: Math.floor(Number(draft.agent_max_turns_per_hour)),
    agent_max_tool_iterations: Math.floor(Number(draft.agent_max_tool_iterations)),
    agent_max_history_turns: Math.floor(Number(draft.agent_max_history_turns)),
    agent_tool_result_max_chars: Math.floor(Number(draft.agent_tool_result_max_chars)),
    updated_at: new Date().toISOString(),
  }

  const { error } = await client.from('kb_pipeline_configs').update(payload).is('source_id', null)
  if (error) throw error
  return normalizeKbAgentBehavior(payload)
}
